module.exports = __webpack_public_path__ + "img/set_phone@2x.adc70326.png";